import {
  isLocalPreviewHostname,
  resolveMystudioApiOrigin,
} from "../config/localPreview";

export const DEMO_MEMBER_PATH = "/api/v3/local/demo-member";

export function getDemoMemberOrigin() {
  return resolveMystudioApiOrigin();
}

export function isDemoMemberPreviewEnabled({
    hostname = typeof window === "undefined" ? "" : window.location.hostname,
    mode = process.env.REACT_APP_MODE,
    nodeEnv = process.env.NODE_ENV,
    explicitFlag = process.env.REACT_APP_ENABLE_PREVIEW_DATA,
} = {}) {
  return String(nodeEnv || "").trim().toLowerCase() !== "production"
    && String(mode || "").trim().toUpperCase() === "LOCAL"
    && String(explicitFlag || "").trim().toLowerCase() === "true"
    && isLocalPreviewHostname(hostname);
}

export function buildDemoMemberUrl(origin) {
  const normalizedOrigin = String(origin || "").trim().replace(/\/+$/, "");
  return normalizedOrigin ? `${normalizedOrigin}${DEMO_MEMBER_PATH}` : "";
}

export async function requestDemoMember({
  origin = getDemoMemberOrigin(),
  signal,
  fetchImpl = globalThis.fetch,
} = {}) {
  const url = buildDemoMemberUrl(origin);

  if (!url) {
    return {
      configured: false,
      member: null,
      status: null,
    };
  }

  if (typeof fetchImpl !== "function") {
    throw new Error("Demo member fetch is unavailable.");
  }

  const response = await fetchImpl(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    cache: "no-store",
    signal,
  });

  if (!response.ok) {
    throw new Error(`Demo member request failed with status ${response.status}.`);
  }

  const payload = await response.json();
  const member = payload?.result;

  if (!member || typeof member !== "object" || Array.isArray(member)) {
    throw new Error("Demo member response does not contain result.");
  }

  if (!member.sections || typeof member.sections !== "object" || Array.isArray(member.sections)) {
    throw new Error("Demo member response does not contain result.sections.");
  }

  return {
    configured: true,
    member,
    status: payload?.status || null,
  };
}
